module.exports = __webpack_public_path__ + "static/media/segmentation.b7d325bc.png";